import { BaseApiResponse, CommonSearchProps, TotalMapProps } from 'modules/common';

export type INoticeCategory = 'IMPORTANT' | 'GENERAL';
export type INoticeRequestCategory = 'ALL' | 'IMPORTANT' | 'GENERAL';

export interface INotice {
  id: string;
  userId: string;
  userName: string;
  title: string;
  enabled: boolean;
  category: INoticeCategory;
  createdBy: string;
  createdDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  viewCount: number;
  replyCount: number;
}

export interface INoticeDetail extends INotice {
  content: string;
  replyDtoList: INoticeReply[];
  attachments: INoticeAttachment[];
  files: File[];
}

export interface INoticeReply {
  id: string;
  userId: string;
  userName: string;
  content: string;
  createdDate: string;
  lastModifiedDate: string;
}

export interface INoticeAttachment {
  id: string;
  url: string;
  fileName: string;
  size: number;
  fileExt: string;
}

//
export interface ResNotices extends BaseApiResponse {
  resultList: INotice[];
}

export interface ResNoticeDetail extends BaseApiResponse {
  resultObject: INoticeDetail;
}

export interface ReqFetchNotices extends CommonSearchProps {
  startDate: string;
  endDate: string;
  category: INoticeRequestCategory;
  keyword?: string;
}

export interface ReqCreateNotice {
  title: string;
  content: string;
  category: INoticeCategory;
  files?: File[];
}

export interface UpdateNoticeRequest {
  noticeId: string;
  title: string;
  content: string;
  category: INoticeCategory;
}

export interface ReqUpdateNotice {
  title: string;
  content: string;
  category: INoticeCategory;
}

export interface ReqCreateNoticeAttachment {
  noticeId: string;
  files: File[];
}

export interface ReqDeleteNoticeAttachment {
  noticeId: string;
  fileId: string;
}

export interface CreateNoticeReply {
  content: string;
}

export interface ReqCreateNoticeReply {
  noticeId: string;
  reply: CreateNoticeReply;
}

export interface ReqUpdateNoticeReply {
  noticeId: string;
  reply: CreateNoticeReply;
}

export enum IDialogType {
  // 아무 상태도 아님
  none,

  // 단순 알리는 Dialog
  alert,

  // Yes No 선택하는 Dialog
  confirm
}

export interface IDialog {
  type: IDialogType;
  message?: string;
  isNavigate: boolean;
  callback: () => void;
}

export interface IDialogYN {
  message?: string;
  callback: () => void;
}

export interface IPageAutority {
  isReadonly: boolean;
  hasAuthority: boolean;
}

export interface NoticeState {
  noticeDetail: INoticeDetail;
  notices: INotice[];
  totalMap: TotalMapProps;

  replyDetail: INoticeReply;
  fetchNoticesRequest: ReqFetchNotices;

  dialog: IDialog;
}
